import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CgChevronDoubleLeft } from 'react-icons/cg';
import API from '../api/axios';


const ResetPasswordConfirm = () => {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const resetToken = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/staff/confirm-reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ resetToken, newPassword }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setError('');
      } else {
        setError(data.message || 'Something went wrong');
        setMessage('');
      }
    } catch (err) {
      setError('An error occurred while resetting your password.');
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow-md w-96"
      >
         <div className='flex gap-4'>
                    <button onClick={() => navigate('/dashboard')}>
                    <CgChevronDoubleLeft size={24}/>
                    </button>
                    <h2 className="text-2xl font-bold mb-4">Set New Password</h2>
                    </div>
    
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">New Password</label>
          <input
            type="password"
            className="w-full p-2 border rounded focus:outline-none focus:ring"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
        >
          Reset Password
        </button>
        {message && <p className="text-green-500 mt-4">{message}</p>}
        {error && <p className="text-red-500 mt-4">{error}</p>}
      </form>
      
    </div>
  );
};

export default ResetPasswordConfirm;
